export default {
  LOCALE_HTML: {
    "msg.language": 'cn',
    "msg.title": "标题",
    "msg.type": "问题分类",
    "msg.des": "问题描述",
    "msg.phone":'手机号',
    "msg.email":'邮箱',
    'msg.choose': '选择自助提交问题类型',
    'msg.detail': '自助问题详情',
    'msg.back': '返回',
    'your.msg': '自助提交',
    'msg.record': '自助问题记录',
    'msg.success': '提交成功',
    'to.record': '前往已提交问题',
    'completed':'完成',
    'submit': '提交',
    'success.desc': '您的问题已成功提交，感谢您的反馈',
    'msg.form.input':'请输入',
    'msg.reply' : '回复',
    'msg.revoke' : '撤销',
    'comment.suc': '感谢您的评价！',
    'comment.fail': '提交失败',
    "comment.placeholder": "欢迎给我们的服务提建议",
    'reply.suc': '提交成功！',
    'reply.fail': '请输入您的回复内容',
    'revoke.suc': '撤销成功！',
    'revoke.fail': '撤销失败',
    "reply.placeholder": '请输入您的回复内容',
    "msg.more":"查看更多",
    "msg.collapse": '收起',
    "msg.myservice": '我的服务评价',
    "msg.evaluate": '服务评价',
    "msg.evaluateTitle": '服务评价',
    "msg.score" : '评分：',
    "msg.remark" : '评语：',
    'msg.status.created': '已创建',
    'msg.status.pending': '待受理',
    'msg.status.processing': '受理中',
    'msg.status.solved': '已完成',
    'msg.status.revoked': '已撤销',
    'msg.service.reply': '客服回复',
    'msg.my.reply': '我的回复',
    'msg.my.revoke': '我的撤销',
    "msg.toast.des":"问题描述为空",
    "msg.toast.type":"问题分类为空",
    "msg.toast.title":"标题为空",
    "msg.toast.none":"不能为空",
    "msg.toast.noAnnex":"请上传附件",
    "msg.toast.noEmail":"邮箱不能为空",
    "msg.toast.noTel":"手机号不能为空",
    "msg.toast.email":"请输入正确的邮箱",
    "msg.toast.tel":"请输入正确的手机号",
    "msg.toast.num":"请输入正确的数字",
    'msg.toast.annex': '请上传附件',
    "msg.toast.char":"请输入正确的字符",
    "msg.list.none":"暂无数据",
    "msg.form.choose":"请选择",
    "msg.form.sure":"确定",
    "msg.form.search":"搜索...",
    "msg.form.uploadError": "上传附件格式不符合要求",
    // "file.size.limit":"文件大小不能超过20MB",
    "file.size.limit":"文件大小不能超过200MB",
    // "detail.file.limit": "最多10个，大小不超过20M",
    "detail.file.limit": "最多10个，大小不超过200M",
    "form.question.des.tip": "请输入问题描述",
    "form.title.tip": "请输入标题",
    "form.class.tip": "请选择问题分类",
    "upload.file":"上传附件",
    "file.count.limit": "最多只能上传10个附件",
    "select.search.placeholder": "搜索关键字",
    "msg.form.sizeError1": "请上传小于5M的附件",
    // "msg.form.sizeError2": "请上传小于20M的附件",
    "msg.form.sizeError2": "请上传小于200M的附件",
    "msg.form.submit": "提交中...",
    "msg.form.upload": "上传中...",
  },
  LOCALE_SYSTEM: {
    MSG004: ({ name }) => `您好，客服${name}接受了您的请求`,
    MSG012: (color) => ` 您可以<span style="color:${color};text-decoration:underline;" class="js-leave-msg">自助提交</span>`,
    MSG013: '发给客服',
  }
}
